/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Price_On_RequestInputs */

const en_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price on Request`)
};

const es_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio a consultar`)
};

const fr_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix sur demande`)
};

const de_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis auf Anfrage`)
};

const ja_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格は要相談`)
};

const zh_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格请询价`)
};

const ar_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر عند الطلب`)
};

const id_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Berdasarkan Permintaan`)
};

const it_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo su Richiesta`)
};

const ru_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена по запросу`)
};

const pt_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço sob Consulta`)
};

const ko_storefront_price_on_request = /** @type {(inputs: Storefront_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 문의`)
};

/**
* | output |
* | --- |
* | "Price on Request" |
*
* @param {Storefront_Price_On_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_price_on_request = /** @type {((inputs?: Storefront_Price_On_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Price_On_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_price_on_request(inputs)
	if (locale === "es") return es_storefront_price_on_request(inputs)
	if (locale === "fr") return fr_storefront_price_on_request(inputs)
	if (locale === "de") return de_storefront_price_on_request(inputs)
	if (locale === "ja") return ja_storefront_price_on_request(inputs)
	if (locale === "zh") return zh_storefront_price_on_request(inputs)
	if (locale === "ar") return ar_storefront_price_on_request(inputs)
	if (locale === "id") return id_storefront_price_on_request(inputs)
	if (locale === "it") return it_storefront_price_on_request(inputs)
	if (locale === "ru") return ru_storefront_price_on_request(inputs)
	if (locale === "pt") return pt_storefront_price_on_request(inputs)
	return ko_storefront_price_on_request(inputs)
});